module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-YOUTUBE.0435067f.png";